import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config";

const LocationPage = () => {
  const [blocks, setBlocks] = useState([]);
  const [floors, setFloors] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [blockFloorPlaces, setBlockFloorPlaces] = useState([]);
  const [locations, setLocations] = useState([]);
  const [blockFloors, setBlockFloors] = useState([]);


  const [filterText, setFilterText] = useState("");

  // Forms
  const [blockForm, setBlockForm] = useState({ block_name: "" });
  const [floorForm, setFloorForm] = useState({ floor_name: "", block_id: "" });
  const [roomForm, setRoomForm] = useState({ place_name: "", floor_id: "" });
  const [locForm, setLocForm] = useState({ department_id: "", flr_blk: "" });

  /* ===========================================
   * LOADERS
   * ===========================================
   */
  const authHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  });

  const loadBlocks = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/blocks", {
        headers: authHeader(),
      });
      const d = res.data;
      setBlocks(Array.isArray(d.data) ? d.data : []);
    } catch (err) {
      console.error("Blocks load error:", err);
      toast.error("Failed to load blocks");
    }
  };





const loadBlockFloors = async () => {
  try {
    const res = await axios.get(API_BASE_URL + "/locations/block-floor");
    setBlockFloors(res.data.data || []);
  } catch (err) {
    toast.error("Failed to load blocks & floors");
  }
};
useEffect(() => {
  loadBlockFloors();
}, []);


  const loadFloors = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/floors", {
        headers: authHeader(),
      });
      const d = res.data;
      setFloors(Array.isArray(d.data) ? d.data : []);
    } catch (err) {
      console.error("Floors load error:", err);
      toast.error("Failed to load floors");
    }
  };

  const loadRooms = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/rooms", {
        headers: authHeader(),
      });
      const d = res.data;
      setRooms(Array.isArray(d.data) ? d.data : []);
    } catch (err) {
      console.error("Rooms load error:", err);
      toast.error("Failed to load rooms");
    }
  };

  const loadDepartments = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/departments", {
        headers: authHeader(),
      });
      const d = res.data;
      setDepartments(Array.isArray(d.data) ? d.data : []);
    } catch (err) {
      console.error("Departments load error:", err);
      toast.error("Failed to load departments");
    }
  };
const loadBlockFloorPlaces = async () => {
  try {
    const res = await axios.get(API_BASE_URL + "/getBlockFloorPlace", {
      headers: authHeader(),
    });

    // FIXED — use res.data.data directly
    setBlockFloorPlaces(res.data.data || []);
  } catch (err) {
    console.error("BlockFloorPlaces load error:", err);
    toast.error("Failed to load location combo list");
  }
};



// CALL ON PAGE LOAD
useEffect(() => {
  loadBlockFloorPlaces();
}, []);



  const loadLocations = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/locations", {
        headers: authHeader(),
      });
      const d = res.data;
      setLocations(Array.isArray(d.data) ? d.data : []);
    } catch (err) {
      console.error("Locations load error:", err);
      toast.error("Failed to load locations");
    }
  };

  useEffect(() => {
    loadBlocks();
    loadFloors();
    loadRooms();
    loadDepartments();
    loadBlockFloorPlaces();
    loadLocations();
  }, []);

  /* ===========================================
   * ADD BLOCK
   * ===========================================
   */
  const handleBlockSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(API_BASE_URL + "/blocks", blockForm, {
        headers: authHeader(),
      });
      toast.success("Block added successfully!");
       
      setBlockForm({ block_name: "" });
      loadBlocks();
      loadBlockFloorPlaces();
    } catch (err) {
      if (err.response?.status === 422 && err.response.data.errors) {
        Object.values(err.response.data.errors).forEach((msg) =>
          toast.error(msg[0])
        );
      } else {
        console.error("Add block error:", err);
        toast.error("Error adding block");
      }
    }
  };

  /* ===========================================
   * ADD FLOOR
   * ===========================================
   */
  const handleFloorSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(API_BASE_URL + "/floors", floorForm, {
        headers: authHeader(),
      });
      toast.success("Floor added successfully!");
       
      setFloorForm({ floor_name: "", block_id: "" });
      loadFloors();
      loadBlockFloorPlaces();
    } catch (err) {
      if (err.response?.status === 422 && err.response.data.errors) {
        Object.values(err.response.data.errors).forEach((msg) =>
          toast.error(msg[0])
        );
      } else {
        console.error("Add floor error:", err);
        toast.error("Error adding floor");
      }
    }
  };

  /* ===========================================
   * ADD ROOM
   * ===========================================
   */
  const handleRoomSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(API_BASE_URL + "/rooms", roomForm, {
        headers: authHeader(),
      });
      toast.success("Room added successfully!");
       
      setRoomForm({ place_name: "", floor_id: "" });
      loadRooms();
      loadBlockFloorPlaces();
    } catch (err) {
      if (err.response?.status === 422 && err.response.data.errors) {
        Object.values(err.response.data.errors).forEach((msg) =>
          toast.error(msg[0])
        );
      } else {
        console.error("Add room error:", err);
        toast.error("Error adding room");
      }
    }
  };

  /* ===========================================
   * ADD DEPARTMENT LOCATION
   * ===========================================
   */
  const handleLocationSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        API_BASE_URL + "/locations",
        {
          department_id: locForm.department_id,
          flr_blk: locForm.flr_blk, // "block-floor-place"
        },
        { headers: authHeader() }
      );

      toast.success("Location added successfully!");
     

      setLocForm({ department_id: "", flr_blk: "" });
      loadLocations();
    } catch (err) {
      if (err.response?.status === 422 && err.response.data.errors) {
        Object.values(err.response.data.errors).forEach((msg) =>
          toast.error(msg[0])
        );
      } else {
        console.error("Add location error:", err);
        toast.error("Error adding location");
      }
    }
  };

  /* ===========================================
   * DELETE LOCATION
   * ===========================================
   */
  const deleteLocation = async (locId) => {
    if (!window.confirm("Delete this location?")) return;

    try {
      await axios.delete(API_BASE_URL + `/locations/${locId}`, {
        headers: authHeader(),
      });

      toast.success("Location deleted successfully!");
      
      loadLocations();
    } catch (err) {
      console.error("Delete location error:", err);
      toast.error("Error deleting location");
    }
  };

  /* ===========================================
   * DATATABLE
   * ===========================================
   */
  const columns = [
    
    {
      name: "Department",
      selector: (row) => row.department_name,
      sortable: true,
    },
    {
      name: "Block",
      selector: (row) => row.block_name,
      sortable: true,
    },
    {
      name: "Floor",
      selector: (row) => row.floor_name,
      sortable: true,
    },
    {
      name: "Room",
      selector: (row) => row.place_name,
      sortable: true,
    },
  ];

  const filteredLocations = (locations || []).filter((item) => {
    const txt = filterText.toLowerCase();
    return (
      item.department_name?.toLowerCase().includes(txt) ||
      item.block_name?.toLowerCase().includes(txt) ||
      item.floor_name?.toLowerCase().includes(txt) ||
      item.place_name?.toLowerCase().includes(txt)
    );
  });

  /* ===========================================
   * RENDER
   * ===========================================
   */
  return (
    <div className="container mt-4">
     <ToastContainer position="bottom-right" />

      <div className="row m-b-1">
        {/* LEFT column: Blocks / Floors / Rooms */}
        <div className="col-md-4">
          {/* BLOCKS */}
          <div className="card mb-3">
            <h6 className="card-header">Add New Block</h6>
            <div className="card-body">
              <form onSubmit={handleBlockSubmit}>
                <div className="mb-3 required-tooltip " style={{ position: "relative" }}>
                  <label className="form-label">Block Name</label>
                  <input
                    type="text"
                    className="form-control required-input required-tooltip"
                    name="block_name"
                    value={blockForm.block_name}
                    onChange={(e) =>
                      setBlockForm({ ...blockForm, block_name: e.target.value })
                    }
                    placeholder="Block Name"
                  />
                </div>
                <button type="submit" className="btn btn-primary w-100">
                  Save Block
                </button>
              </form>
            </div>
          </div>

          {/* FLOORS */}
          <div className="card mb-3">
            <h6 className="card-header">Add New Floor</h6>
            <div className="card-body">
              <form onSubmit={handleFloorSubmit}>
                <div className="mb-3 required-tooltip " style={{ position: "relative" }}>
                  <label className="form-label">Floor Name</label>
                  <input
                    type="text"
                    className="form-control required-input"
                    name="floor_name"
                    value={floorForm.floor_name}
                    onChange={(e) =>
                      setFloorForm({
                        ...floorForm,
                        floor_name: e.target.value,
                      })
                    }
                    placeholder="Floor Name"
                  />
                </div>

                <div className="mb-3 ">
                  <label className="form-label ">Block</label>
                  <Select  classNames={{
    control: () => "required-select required-tooltip "
  }}
                    options={blocks.map((b) => ({
                      value: b.block_id,
                      label: b.block_name,
                    }))}
                    value={
                      blocks
                        .map((b) => ({
                          value: b.block_id,
                          label: b.block_name,
                        }))
                        .find((opt) => opt.value === floorForm.block_id) ||
                      null
                    }
                    onChange={(selected) =>
                      setFloorForm({
                        ...floorForm,
                        block_id: selected ? selected.value : "",
                      })
                    }
                    placeholder="Select block..."
                    className="form-control p-0 "
                  />
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  Save Floor
                </button>
              </form>
            </div>
          </div>

          {/* ROOMS */}
          <div className="card mb-3">
            <h6 className="card-header">Add New Room</h6>
            <div className="card-body">
              <form onSubmit={handleRoomSubmit}>
                <div className="mb-3 required-tooltip">
                  <label className="form-label">Room Name</label>
                  <input
                    type="text"
                    className="form-control required-input"
                    name="place_name"
                    value={roomForm.place_name}
                    onChange={(e) =>
                      setRoomForm({
                        ...roomForm,
                        place_name: e.target.value,
                      })
                    }
                    placeholder="Room Name"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Floor</label>
                  <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
                    options={floors.map((f) => ({
                      value: f.floor_id,
                      label: `${f.floor_name} (${f.block_name})`,
                    }))}
                    value={
                      floors
                        .map((f) => ({
                          value: f.floor_id,
                          label: `${f.floor_name} (${f.block_name})`,
                        }))
                        .find((opt) => opt.value === roomForm.floor_id) || null
                    }
                    onChange={(selected) =>
                      setRoomForm({
                        ...roomForm,
                        floor_id: selected ? selected.value : "",
                      })
                    }
                    placeholder="Select floor..."
                    className="form-control p-0"
                  />
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  Save Room
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* RIGHT column: Add Location + Locations Table */}
        <div className="col-md-8">
          {/* Add Location */}
          <div className="card mb-3">
            <h6 className="card-header">Add New Location</h6>
            <div className="card-body">
              <form onSubmit={handleLocationSubmit}>
                {/* Department */}
                <div className="mb-3 required-tooltip">
                  <label className="form-label">Select Department</label>
                  <Select  classNames={{
    control: () => "required-select"
  }}
                    options={departments.map((d) => ({
                      value: d.department_id,
                      label: d.department_name,
                    }))}
                    value={
                      departments
                        .map((d) => ({
                          value: d.department_id,
                          label: d.department_name,
                        }))
                        .find((opt) => opt.value === locForm.department_id) ||
                      null
                    }
                    onChange={(selected) =>
                      setLocForm((prev) => ({
                        ...prev,
                        department_id: selected ? selected.value : "",
                      }))
                    }
                    placeholder="Select department..."
                    className="form-control p-0"
                  />
                </div>

                {/* Block / Floor / Room combined */}
              {/* Block / Floor / Room combined */}
<div className="mb-3 required-tooltip">
  <label className="form-label">Select Block / Floor / Room</label>

<Select  classNames={{
    control: () => "required-select"
  }}
  options={blockFloorPlaces}
  value={blockFloorPlaces.find(opt => opt.value === locForm.flr_blk) || null}
  onChange={(selected) =>
    setLocForm(prev => ({ ...prev, flr_blk: selected?.value || "" }))
  }
  placeholder="Select Block / Floor / Room..."
  className="form-control p-0"
/>



</div>


                <button type="submit" className="btn btn-primary">
                  Save Location
                </button>
              </form>
            </div>
          </div>

          {/* Location List */}
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <strong>Location List</strong>
              <input
                type="text"
                className="form-control form-control-sm d-inline-block"
                style={{ width: "200px" }}
                placeholder="Search..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
            <div className="card-body">
              <DataTable
                columns={columns}
                data={filteredLocations}
                pagination
                highlightOnHover
                striped
                persistTableHead
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationPage;
